export default __webpack_public_path__ + "static/media/doctorsPortal.9cd0c9da.png";